import React, { Suspense } from "react";
import { Box, CircularProgress } from "@mui/material";

// Same lazy split as RepeatabilityGamutPlot: Plotly is loaded on demand.
const MeasurementDriftPlotInner = React.lazy(() => import("./MeasurementDriftPlotInner"));

/** See MeasurementDriftPlotInner for the props and the drawing rules. */
export default function MeasurementDriftPlot(props) {
    const height = props.height ?? 520;
    return (
        <Suspense
            fallback={
                <Box sx={{ height, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress size={28} thickness={4} aria-label="Loading the drift plot" />
                </Box>
            }
        >
            <MeasurementDriftPlotInner {...props} />
        </Suspense>
    );
}
